/** What a notes box is holding: its text, and whether someone has typed into it since it last matched the saved notes. */
export interface INoteDraft {
  text: string | null;
  editing: boolean;
}

export function noteDraftFrom(saved: string | null): INoteDraft {
  return { text: saved, editing: false };
}

/**
 * Lines a notes box up with the latest saved notes. A box nobody is typing in follows them, so a
 * driver's notes saved from Collect appear without a reload. A box with unsaved typing keeps it,
 * until the saved notes catch up with what was typed (i.e. the save has landed).
 */
export function syncNoteDraft(draft: INoteDraft, saved: string | null): INoteDraft {
  if (draft.text === saved) return draft.editing ? noteDraftFrom(saved) : draft;
  return draft.editing ? draft : noteDraftFrom(saved);
}

/** Only typing that differs from the saved notes is worth sending; clicking in and out of the box is not. */
export function shouldSaveNoteDraft(draft: INoteDraft, saved: string | null): boolean {
  return draft.editing && draft.text !== saved;
}
